/**
 * Defines how adjustments will be made to the contract should one or more of the extraordinary events occur.
 * tag: 2602
 * @readonly
 * @enum {number} (int)
 */
export enum ExtraordinaryEventAdjustmentMethod {
  CalculationAgent = 0,
  OptionsExchange = 1,
}
